import { render } from "./AggregateSettlement.vue?vue&type=template&id=a4324b1e"
import script from "./AggregateSettlement.vue?vue&type=script&lang=js"
export * from "./AggregateSettlement.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__